export default __webpack_public_path__ + "media/1adc37f2c29356f25a0470182f6354b4bd5f0bfe02d634a46fe9e4a9bee9e5e1.svg";